import { render } from "./CfdisPorCobrar.vue?vue&type=template&id=7ff1825c&scoped=true"
import script from "./CfdisPorCobrar.vue?vue&type=script&lang=js"
export * from "./CfdisPorCobrar.vue?vue&type=script&lang=js"

import "./CfdisPorCobrar.vue?vue&type=style&index=0&id=7ff1825c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff1825c"]])

export default __exports__